import React from "react";
import PropTypes from "prop-types";

/**
 * DataCard1 — responsive KPI/stat cards (Argon-inspired design)
 *
 * Props:
 *  - healthCareData: array of { icon: ReactNode, title: string, value: string, sub?: string, colorBg?: string }
 */
export default function DataCard1({ healthCareData = [] }) {
    return (
        <div className="flex flex-wrap gap-3">
            {healthCareData.map((item, idx) => (
                <article
                    key={idx}
                    className="flex flex-1 min-w-[250px] items-center justify-between gap-3 px-3 py-2 bg-white rounded-2 border border-slate-100 shadow-[0_4px_12px_rgba(0,0,0,0.05)] hover:shadow-[0_6px_20px_rgba(0,0,0,0.1)] transition-all duration-300"
                    role="group"
                    aria-label={`${item.title} card`}
                >
                    {/* Icon */}
                    <div
                        className={`flex items-center justify-center w-11 h-11 rounded-full text-white flex-shrink-0 
              ${item.colorBg || "bg-gradient-to-r from-sky-500 to-indigo-500"} 
              shadow-md shadow-indigo-100`}
                        aria-hidden="true"
                    >
                        {React.isValidElement(item.icon)
                            ? React.cloneElement(item.icon, { className: "w-5 h-5" })
                            : <span className="w-5 h-5" />}
                    </div>

                    {/* Text block */}
                    <div className="flex flex-col text-right text-wrap">
                        <div className="text-sm font-semibold text-slate-500 tracking-wide">
                            {item.title}
                        </div>
                        <div className="text-xl font-bold text-slate-800 leading-snug">
                            {item.value}
                        </div>
                        {item.sub && (
                            <div className="text-xs text-slate-400 mt-0.5">{item.sub}</div>
                        )}
                    </div>
                </article>
            ))}
        </div>
    );
}

DataCard1.propTypes = {
    healthCareData: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.node.isRequired,
            title: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
            sub: PropTypes.string,
            colorBg: PropTypes.string,
        })
    ),
};

DataCard1.defaultProps = {
    healthCareData: [],
};
